export function tickerValuePostFormatter(max: number, value: number): number {
    return value * max;
}
